export default __webpack_public_path__ + "static/media/substrate1.80bc9072.jpg";